const checkEcheckFormValidation = (field, errors) => {

    let isValid = true;
    let isErrors = errors;

    if (field.amount === '' || field.amount === '0.00') {
        isErrors.amount = 'Amount should be greater than 0.'
        isValid = false;
    } else if (Number(field.amount.replace(/,/g, "")) > 30000 ) {
        isErrors.amount = 'Amount should be too larger.'
        isValid = false;
    } else {
        isErrors.amount = '';
    }

    if(field.bankAccountType === ''){
        isErrors.bankAccountType = 'Please select account holder type.';
        isValid = false;
    } else {
        isErrors.bankAccountType = ''
    }

    if(field.accountType === ''){
        isErrors.accountType = 'Please select account type.';
        isValid = false;
    } else {
        isErrors.accountType = ''
    }

    if (field.bankAccountType === 'Personal' ) {
        if (field.firstName.trim() === '') {
            isErrors.firstName = 'Account holder first name is required.';
            isValid = false;
        } else {
            isErrors.firstName = '';
        }

        if (field.lastName.trim() === '') {
            isErrors.lastName = 'Account holder last name is required.';
            isValid = false;
        } else {
            isErrors.lastName = '';
        }

    } else {
        if (field.businessName.trim() === '') {
            isErrors.businessName = 'Name on account is required.';
            isValid = false;
        } else {
            isErrors.businessName = '';
        }
    }

    if (field.routingNumber.trim() === '') {
        isErrors.routingNumber = 'Routing / ABA number is required.';
        isValid = false;
    } else if (field.routingNumber.length > 0 && field.routingNumber.length < 9) {
        isErrors.routingNumber = 'Routing / ABA number is invalid.';
        isValid = false;
    } else {
        isErrors.routingNumber = '';
    }

    if (field.accountNumber.trim() === '') {
        isErrors.accountNumber = 'Account number is required.';
        isValid = false;
    } else if (field.accountNumber.length > 0 && field.accountNumber.length < 4) {
        isErrors.accountNumber = 'Account number is invalid.';
        isValid = false;
    } else {
        isErrors.accountNumber = '';
    }

    if (field.address1 === '') {
        isErrors.address1 = 'Billing address is required.';
        isValid = false;
    } else {
        isErrors.address1 = '';
    }
    
    //State:
    if(field.state === ''){
        isErrors.state = 'Please select billing state.';
        isValid = false;
    } else {
        isErrors.state = ''
    }

    if (field.postalCode === '') {
        isErrors.postalCode = 'Billing zip/postal code is required.';
        isValid = false;
    } else if (field.postalCode.length < 5) {
        isErrors.postalCode = 'Billing zip/postal code is invalid.';
        isValid = false;
    } else {
        isErrors.postalCode = '';
    }

    //Email:
    if(field.email.trim().length === 0 ){
        isErrors.email = 'Email is required.';
        isValid = false;
    } else if(!field.email.trim().match(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/))){
         isErrors.email = 'Email is invalid.';
        isValid = false;
    }  else {
        isErrors.email = '';
    }

    //Receipt Email:
    if(field.receiptEmails.trim().length > 0 ){

        const emailList = field.receiptEmails.trim().split(',');
        const newList = emailList.map((email) => {
            return email.trim();
        });
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        
        // check every email valid
        const areAllValid = newList.every(email => {
            const singleEmail = email.trim();
            return singleEmail.length > 0 && emailRegex.test(singleEmail);
        });
        
        //check duplicate email:
        const uniqueEmails = new Set(newList);
        const hasDuplicates = uniqueEmails.size !== newList.length;
        const duplicateWithMainEmail = newList.includes(field.email.trim());

        if(newList.length > 5){
            isErrors.receiptEmails = "Only add maximum 5 additional receipt emails.";
            isValid = false;
        } else if(duplicateWithMainEmail){
            isErrors.receiptEmails = "Additional receipt email duplicate with primary email.";
            isValid = false;
        } else if (!areAllValid) {
            isErrors.receiptEmails = "Additional receipt emails are invalid.";
            isValid = false;
        } else if(hasDuplicates){
            isErrors.receiptEmails = "Duplicate additional emails are not allowed.";
            isValid = false;
        } else {
            isErrors.receiptEmails = '';
        }
    } else {
        isErrors.receiptEmails = '';
    }

    return { isValid, isErrors };
}

export default checkEcheckFormValidation;



